import { ShowCaseActionType } from "./enums/showCaseActionType";

export class ShowcaseInsurance {
  /** Заголовок страхования */
  public InsuranceCaption: string = "";

  /** Описание страхования */
  public InsuranceDetail: string = "";

  /** Тип действия для просмотра условий страхования */
  public ActionType: ShowCaseActionType = ShowCaseActionType.None;

  /** Ссылка на просмотр условий страхования */
  public ActionLink: string = "";

  /** Описание по расчету */
  public Description: string = "";

  /** Текст, при отключенном страховании */
  public FalseInsuranceTumblerDescription: string = "";

  /** Выбрано по умолчанию */
  public IsDefault: boolean = false;

  constructor(src: any) {
      this.InsuranceCaption = src.insuranceCaption ?? "";
      this.InsuranceDetail = src.insuranceDetail ?? "";
      this.ActionType = src.actionType ?? ShowCaseActionType.None;
      this.ActionLink = src.actionLink ?? "";
      this.Description = src.description ?? "";
      this.FalseInsuranceTumblerDescription = src.falseInsuranceTumblerDescription ?? "";
      this.IsDefault = src.isDefault ?? false;
  }
}